import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SectionType } from 'src/app/screens/consultation-review/section.enum';

@Component({
  selector: 'app-summary-review-comment',
  templateUrl: './summary-review-comment.component.html',
  styleUrls: ['./summary-review-comment.component.scss']
})
export class SummaryReviewCommentComponent implements OnInit {
  @ViewChild('scrollContainer', { static: false }) scrollContainer!: ElementRef;
  @Input() commentedData: any;
  @Output() onCommentView = new EventEmitter;

  constructor() { }

  ngOnInit(): void {
  }

  scrollLeft(): void {
    this.scrollContainer.nativeElement.scrollBy({ left: -300, behavior: 'smooth' });
  }

  scrollRight(): void {
    this.scrollContainer.nativeElement.scrollBy({ left: 300, behavior: 'smooth' });
  }

  getSectionName(sectionName: string): string {
    switch (sectionName) {
      case SectionType.CASE_SUMMARY:
        return 'Case Summary';
      case SectionType.TREATMENT_PLAN_SUMMARY:
        return 'Treatment Plan';
      case SectionType.SESSION_FORM_SUMMARY:
        return 'Session Form';
      default:
        return '';
    }
  }

  handleOnView(commentData: any) {
    this.onCommentView.emit(commentData);
  }

}
